import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  IcecontrolPermission
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { reportindex } from 'projects/icemedx-lib/src/models/reports/reportindex';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { otheritems } from '../../../../icemedx-lib/src/models/otheritems/otheritems';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { Validators, FormGroup } from '@angular/forms';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { otheritemsreceiving } from '../../../../icemedx-lib/src/models/otheritems/otheritemsreceiving';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { otheritemsjournal } from '../../../../icemedx-lib/src/models/accounting/otheritemsjournal';

@Component({
  selector: 'app-ledger',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  providers: [AppService, IceNavService]
})
export class ItemComponent implements OnInit, IBaseView{

  // data members
  itemObj: otheritems = null;
  totalItemsReceived: number = 0.0;
  totalItemsSold: number = 0.0;
  itemReceiving: otheritemsreceiving[] = [];
  itemsSold: otheritemsjournal[] = [];

  sectionTagEditItem: string = "EditItemSection";

  // member settings
  itemSettings: IcepanelcontainerSettings = null;
  itemPermission: IcecontrolPermission = null;
  invCodeQualCtrl: IcecontrolSettings = null;
  invCodeCtrl: IcecontrolSettings = null;
  invUnitCtrl: IcecontrolSettings = null;
  invCostMethodCtrl: IcecontrolSettings = null;

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private acctSvc: AccountingService,
    private medCodeSvc: MedicalcodesService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {

    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Other Item", {}, true, "");

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufOtherItemsSoldandServices).default_access;
    this.itemPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufOtherItemsSoldandServices, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
    }
    else {
      this.activatedRoute.params.subscribe(next => {
        this.acctSvc.getOtherItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), next.key, next.itemno).subscribe(
          data => {
            if (data && data.length > 0 && data[0] != null) {
              this.itemSettings = this.viewSetup(data[0]);
            }
          },
          error => {
            console.log(JSON.stringify(this.acctSvc.getLastErrors()));
          });
      });
    }


  }

  viewSetup(dat: IIceEntity): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      if (dat == null) {
        return null;
      }

      this.itemObj = <otheritems>dat;
      this.itemObj["code_object"] = this.itemObj.code.length == 0 ? "" : JSON.stringify([{ value: this.itemObj.code, name: this.itemObj.code_txt.length == 0 ? this.itemObj.code : this.itemObj.code_txt }]);

      let tables: IcemattableSettings[] = [
      ];
      let groups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      /// Item New Panel
      this.invCodeQualCtrl = new IcecontrolSettings("iceselect", { menuItems: MedicalcodesService.getMedicalCodeTypeList(), width: "475px" }, null, null, "code_list_qualifier_code", "Select Code Type")
        .setControlName("code_list_qualifier_code")
        .createFormControl("", []);

      this.invCodeQualCtrl.setOptions(MedicalcodesService.getMedicalCodeTypeList());

      this.invCodeCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "475px" }, null, null, "code_object", "Enter Medical Code")
        .setControlName("code_object")
        .createFormControl("", []);

      this.invUnitCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "unit_type", "Select Unit")
        .setControlName("unit_type")
        .createFormControl("", [Validators.required]);

      this.invCostMethodCtrl = new IcecontrolSettings("iceselect", { menuItems: AccountingService.getInventoryMethods(), width: "475px" }, null, null, "cost_method", "Select Inventory Cost Method")
        .setControlName("cost_method")
        .createFormControl(IceTypes.InventoryMethod.imFIFO.toString(), [Validators.required]);

      this.invCostMethodCtrl.setOptions(AccountingService.getInventoryMethods());

      let idControls = [
        new IcecontrolSettings("icelabel", { value: "Stock Num:", h3: true, width: "200px" }, null, null, "item_stock_num", "Enter Stock Num")
          .setControlName("item_stock_num")
          .createFormControl("", [Validators.required]),
        new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "itm_name", "Enter Name of Item")
          .setControlName("itm_name")
          .createFormControl("", [Validators.required]),
        new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "sku_num", "Enter SKU Num")
          .setControlName("sku_num")
          .createFormControl("", []),
        this.invCodeQualCtrl,
        this.invCodeCtrl,
        new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "price", "Enter Price")
          .setControlName("price")
          .createFormControl(0, [Validators.required]),
        new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "cost", "Enter Cost")
          .setControlName("cost")
          .createFormControl(0, [Validators.required]),
        this.invUnitCtrl,
        this.invCostMethodCtrl,
      ];

      let itemEditPanel = this.appSvc.viewEditPanelSection(this.sectionTagEditItem, idControls, false);
      let itemSections: IcepanelsectionSettings[] = [
        itemEditPanel
      ];

      let headerControls = [
        new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, this.appSvc.getEditPanelSectionSaveID(this.sectionTagEditItem)),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, this.appSvc.getEditPanelSectionCancelID(this.sectionTagEditItem))
      ];

      let panels: IcepanelSettings[] = [
        new IcepanelSettings("ItemEditDetails", Iceutility.guid(false), "Inventory Item", "", itemSections, headerControls)
          .enableForm()
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("InventoryItemEditView", panelrows);

      this.appSvc.setCodeList(this.medCodeSvc, new basecode("QUANTITYUNITOFMEASURE"), this.invUnitCtrl, []);
      this.appSvc.setCodeList(this.medCodeSvc, new basecode("NDCCODE"), this.invCodeCtrl, []);
      this.appSvc.setCodeList(this.medCodeSvc, new basecode("CPTCODE"), this.invCodeCtrl, [], false);

      this.acctSvc.getItemReceiving(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.itemObj.other_items_key).subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            this.itemReceiving = data;

            for (let i = 0; i < this.itemReceiving.length; i++) {
              this.totalItemsReceived += Iceutility.toDouble(this.itemReceiving[i].quantity);
            }
          }
        },
        error => {
          console.log(JSON.stringify(this.acctSvc.getLastErrors()));
        }
      );

      this.acctSvc.getJournal(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", IceTypes.JournalType.jtInventory, IceTypes.coa_types.coaInventory, "", IceTypes.coa_types.coaInventory).subscribe(
        data => {
          if (data != null) {
            for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
              let jrnl: otheritemsjournal = data[ijrnl];
              let crd = Iceutility.toDouble(jrnl.credit);
              if (this.itemObj.other_items_key == jrnl.other_items_key && crd > 0) {
                this.totalItemsSold += Iceutility.toDouble(jrnl.quantity);
                this.itemsSold.push(jrnl);
              }
            }
          }
        },
        error => {
          console.log(error);
        });
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
    setTimeout(() => {
      // Show and Set data
      this.appSvc.showEditPanelSection(this.sectionTagEditItem);
      this.appSvc.editPanelSectionUpdate(this.sectionTagEditItem, false, this.itemObj);
    }, 500);
  }

  getItemReceivingDescription(recv: otheritemsreceiving): string {
    let ret = "";
    if (recv == null) return ret;

    ret = Iceutility.isTextDateTime(recv.date_received) ? Iceutility.getDateTextEx(recv.date_received) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(recv.date_received));
    ret += " - " + "Received. Qty: " + recv.quantity.toString() + " @ " + recv.cost.toString();
    return ret;
  }

  getItemReceivingFooter(recv: otheritemsreceiving): string {
    let ret = "";

    return ret;
  }

  getItemSoldDescription(sold: otheritemsjournal): string {
    let ret = "";
    if (sold == null) return ret;

    ret = Iceutility.isTextDateTime(sold.journal_date) ? Iceutility.getDateTextEx(sold.journal_date) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(sold.journal_date));
    ret += " - " + "Sold Qty: " + sold.quantity.toString() + " @ " + sold.credit.toString();
    if (sold.last_name.length > 0 || sold.trans_account.length > 0) {
      let soldTo = sold.last_name;
      ret += ", " + soldTo;
    }

    if (sold.trans_account.length > 0 && Iceutility.toLong(sold.account_type) > 0) {
      let actType = " (" + DomainService.getDomainType(Iceutility.toLong(sold.account_type)) + ")";
      ret += actType;
    }
    
    return ret;
  }

  getItemSoldFooter(sold: otheritemsjournal): string {
    let ret = "";

    return ret;
  }

  onMatGridRowClick(event) {
    if (event.rowData == null) {
      // To do log error
      return;
    }
    //this.router.navigate([this.navSvc.buildRoute("viewreport/" + event.rowData.report_key, false)]);
  }

  onControlChange(event) {
    if (Iceutility.isdefined(event.autocompleteQuerySettings)) {
      switch (event.autocompleteQuerySettings.id) { // To do: Move this to the new autocompleteQuery event
        case "code_object": {
          if (event["value"] != null && event["value"].length >= 3) {
            let codeQual = this.invCodeQualCtrl.getFormControl().value;
            if (codeQual == "NDC")
              this.appSvc.setCodeList(this.medCodeSvc, new basecode("NDCCODE"), this.invCodeCtrl, [], false, event["value"]);
            else
              this.appSvc.setCodeList(this.medCodeSvc, new basecode("CPTCODE"), this.invCodeCtrl, [], false, event["value"]);
          }
          else if (event["value"] != null && event["value"].length == 0){
            this.appSvc.setCodeList(this.medCodeSvc, new basecode("NDCCODE"), this.invCodeCtrl, [], true);
            this.appSvc.setCodeList(this.medCodeSvc, new basecode("CPTCODE"), this.invCodeCtrl, [], false);
          }
          break;
        }
      }
    }
  }

  onTotalReceivedClick(event) {

  }

  onTotalSoldClick(event) {

  }

  onReceivingItemClick(event) {

  }
  onSoldItemClick(event) {

  }
  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == this.appSvc.getEditPanelSectionCancelID(this.sectionTagEditItem)) {
      this.router.navigate([this.navSvc.buildRoute("accounting/inventory", false)]);
      return;
    }

    if (event.headerCtrl instanceof IcepanelSettings) {
      let itemPanel: IcepanelSettings = event.headerCtrl;
      let itemForm: FormGroup = itemPanel.getForm();
      if (itemForm == null || false == itemForm.valid) {
        console.log("Invalid form");
        return;
      }
    }

    try {
    }
    catch (e) {
      //this.messageService.logMessage(IceTypes.LOGTYPE.ltError, e);
      return;
    }

    if (this.appSvc.processEditPanelSectionButtons(this.sectionTagEditItem, this.appSvc.getEditPanelSectionSaveID(this.sectionTagEditItem), true)) {
      let codeQuaList = MedicalcodesService.getMedicalCodeTypeList().filter(opt => this.itemObj.code_list_qualifier_code == opt.name);
      if (codeQuaList.length > 0) {
        this.itemObj.code_list_qualifier_code = codeQuaList[0].value;
      }

      let unitList = this.invUnitCtrl.getOptions().filter(opt => this.itemObj.unit_type == opt.name);
      if (unitList.length > 0) {
        this.itemObj.unit_type = unitList[0].value;
      }

      let costList = this.invCostMethodCtrl.getOptions().filter(opt => this.itemObj.cost_method == opt.name);
      if (costList.length > 0) {
        this.itemObj.cost_method = costList[0].value;
      }

      this.acctSvc.updateOtherItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.itemObj).subscribe(
        data => {
          this.router.navigate([this.navSvc.buildRoute("accounting/inventory", false)]);
        }, error => {
          console.log(error);
        });
    }

    //this.msg.message_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
    //this.msg.trans_account = this.appSvc.getCurrentAccount();
    //this.msg.account_type = this.appSvc.getCurrentAccountType();
    //this.msg.message_status = IceTypes.trans_status.isReadyToSend;
    //this.msg.trans_type = IceTypes.TRANSTYPE.itNone;
  }
}
